import { useLayoutEffect, useRef, useState, type RefObject } from 'react';

/** カテゴリ1本分の最小幅（px）。これ未満に潰れないよう、必要なら横スクロール */
export const BAR_CHART_MIN_PX_PER_CATEGORY = 70;

/**
 * 棒グラフ・積み上げ棒用: 親幅とデータ本数からチャート内幅（px）を決める。
 */
export function useBarChartScrollContainer(labelCount: number): {
    scrollRef: RefObject<HTMLDivElement | null>;
    /** 内側ラッパーに指定する width（px） */
    innerWidthPx: number;
    /** ResizeObserver で得たスクロール領域の幅（初回前は 0） */
    containerWidth: number;
    /** labelCount * BAR_CHART_MIN_PX_PER_CATEGORY */
    minRequiredWidthPx: number;
} {
    const scrollRef = useRef<HTMLDivElement>(null);
    const [containerWidth, setContainerWidth] = useState(0);

    useLayoutEffect(() => {
        const el = scrollRef.current;
        if (!el) return;
        const measure = () => {
            setContainerWidth(Math.round(el.getBoundingClientRect().width));
        };
        measure();
        const ro = new ResizeObserver(() => measure());
        ro.observe(el);
        return () => ro.disconnect();
    }, []);

    const minRequiredWidthPx = Math.max(0, labelCount) * BAR_CHART_MIN_PX_PER_CATEGORY;
    const innerWidthPx =
        containerWidth > 0
            ? Math.max(containerWidth, minRequiredWidthPx)
            : Math.max(minRequiredWidthPx, 1);

    return { scrollRef, innerWidthPx, containerWidth, minRequiredWidthPx };
}
